import { render } from "./manageTasks.vue?vue&type=template&id=5e89edd0&ts=true"
import script from "./manageTasks.vue?vue&type=script&lang=ts"
export * from "./manageTasks.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__